import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import EmptyLine from "../EmptyLine";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";

export function B24({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.FD01.error_id: {
            const groupProfile = []
            row?.data?.forEach(r => {
                if(!groupProfile.find(x => x.cross_section === r.cross_section))
                    groupProfile.push({
                        cross_section: r.cross_section,
                        data: []
                    })

                const item = groupProfile.find(x => x.cross_section === r.cross_section)
                item.data.push(r)
            })
            // const groupProfile = _.groupBy(row.data, (x) => x.cross_section)
            const profiles = Array.from(new Set(row?.data?.filter(x => !x.is_increase).map(x => x.profile)))
            return (
                <>
                    <ResultText>
                        Flow decreases in the direction of flow for {profiles.join(', ')} profile. These flow rates are highlighted in the following table.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultHeaderCell></ResultHeaderCell>
                            <ResultHeaderCell colSpan={row?.profiles?.length}> Flow Rate (cfs)</ResultHeaderCell>
                        </ResultHeader>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'left'}}>
                                    River Station
                                </ResultHeaderCell>
                                {
                                    row.profiles?.map(p => (
                                        <ResultHeaderCell style={{width: HecRasHelper.getWidth(10), textAlign: 'right'}}>
                                            {p}
                                        </ResultHeaderCell>
                                    ))
                                }
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                groupProfile.map(cs => {
                                    const items = cs.data
                                    const row_data = []
                                    row?.profiles?.forEach(p => {
                                        const val = items.find(x => x.profile === p)
                                        if(val)
                                            row_data.push(val)
                                    })

                                    return (
                                        <ResultRow>
                                            <ResultHeaderCell style={{textAlign: 'left', fontWeight: 'normal'}}>
                                                <CheckCSName csName={cs.cross_section} />
                                            </ResultHeaderCell>
                                            {
                                                row_data?.map(r => (
                                                    <ResultBodyCell style={{textAlign: 'right'}}>
                                                        {r.is_increase ? r.val : ResultCellHighlight('-', r.val)}
                                                    </ResultBodyCell>
                                                ))
                                            }
                                        </ResultRow>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
    }
}